import React from 'react';
export function SiteFooter() {
  return <footer className="bg-ink" data-id="element-179" data-mp="1dr1hztnuk9i9">
      <div className="mx-auto max-w-6xl px-5 pb-24 pt-10 md:px-6 md:py-16" data-id="element-180" data-mp="3r89cz7f3crfw">
        <div className="grid gap-6 border-b border-line pb-8 lg:grid-cols-[1fr_1.2fr] lg:gap-16 lg:pb-12" data-id="element-181" data-mp="3racdwmhs84ze">
          <div data-id="element-182" data-mp="3mfgbqtiu018k">
            <p className="font-display text-lg text-cream md:text-xl" data-id="element-183" data-mp="3hig268mrwgcp">El Libro del Despertar</p>
            <p className="mt-2 font-serif text-base italic text-muted md:text-lg" data-id="element-184" data-mp="3dguvx64qv0bh">
              Conciencia, simbolismo y nuevas perspectivas sobre la realidad.
            </p>
          </div>
          <div data-id="element-185" data-mp="38k4eaedajwny">
            <h2 className="text-xs font-semibold uppercase tracking-[0.15em] text-cream/80" data-id="element-186" data-mp="33if0ws2lj6wp">
              Sobre el producto
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-muted md:text-base" data-id="element-187" data-mp="2ykvlvpy2qq3p">
              EL LIBRO DEL DESPERTAR es una propuesta de lectura digital orientada
              a la exploración de la conciencia, la percepción, el simbolismo y
              las tradiciones espirituales.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-muted md:text-base" data-id="element-188" data-mp="15paetdmr16ix">
              Su propósito es ofrecer una experiencia de lectura que invite a
              reflexionar, conectar conceptos y considerar diferentes
              perspectivas sobre la existencia y la manera en que comprendemos el
              mundo.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-6 text-sm text-muted md:flex-row md:items-start md:justify-between" data-id="element-189" data-mp="1oieat5nfvvgp">
          <nav aria-label="Legal" className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-190" data-mp="1tf4styit114r">
            <a href="#privacidad" className="transition-colors duration-150 hover:text-cream" data-id="element-191" data-mp="1esbgn24l0bgs">Política de privacidad</a>
            <a href="#terminos" className="transition-colors duration-150 hover:text-cream" data-id="element-192" data-mp="1jp1z1w3uzj5d">Términos y condiciones</a>
            <a href="#reembolsos" className="transition-colors duration-150 hover:text-cream" data-id="element-193" data-mp="27ew780d8gjja">Política de reembolsos</a>
          </nav>
          <p className="text-xs md:text-sm" data-id="element-194" data-mp="2m2nwu7wzgv4j">© 2026 EL LIBRO DEL DESPERTAR. Todos los derechos reservados.</p>
        </div>
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-muted/80" data-id="element-195" data-mp="2h3l0rcyzdz8p">
          Producto digital con fines educativos, informativos y de reflexión
          personal. Las interpretaciones espirituales no deben presentarse como
          hechos científicos demostrados.
        </p>
      </div>
    </footer>;
}